/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


$(document).on('scroll', function() {
  if($('.Product__Wrapper').css('min-height') != $('.Product__Info').height()) {
    $('.Product__Wrapper').css('min-height', $('.Product__Info').height());
  }
});




var desktopWistia = '<script src="https://fast.wistia.com/embed/medias/j9tq6qpfxg.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_embed wistia_async_j9tq6qpfxg" style="height:550px;position:relative;width:440px"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/j9tq6qpfxg/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div>';

//var wistiaVideo = '<script src="https://fast.wistia.com/embed/medias/l36zvzzgdm.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:125.0% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_l36zvzzgdm videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/l36zvzzgdm/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';

var responsiveWistia = '<script src="https://fast.wistia.com/embed/medias/j9tq6qpfxg.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:125.0% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_j9tq6qpfxg videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/j9tq6qpfxg/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';

$(document).ready(function(){
  if($('.wistia_responsive_padding').length < 1){
    //Mobile 
    $('div#s-31968c09-f52f-4800-a5dd-07a41340fc57').before(responsiveWistia);
    //Desktop 
//     $('#s-5e53e833-ec10-4ada-9067-9cec54b1d768 > div > div.shg-c-lg-5.shg-c-md-5.shg-c-sm-5.shg-c-xs-12').html(desktopWistia);
  	$('#s-fdbcb691-2178-4cf5-9ce1-11f4e97a50ee > div > div.shg-c-lg-5.shg-c-md-5.shg-c-sm-5.shg-c-xs-12').html(desktopWistia);
  }
  
  if(window.location.href.indexOf('/pages/customer-reviews') > -1){
    $('body').addClass("customer-reviews");
  }

  if($(window).width() < 768) {

    //$('.choose-set-btn.choose-keep-btn a b').html('CHOOSE YOUR SET');
    
    $(window).on('scroll', function() {
        
        var $elem = $("#s-2fdd7792-f48a-4232-9e12-6deb521f9c21"); // First Item hide
        var $elem2 = $("#s-2cd90749-73b0-4a6b-b5f2-d4b7e607ef02");// Second Item Show
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();
        var elemTop = $elem.offset().top;
        var elemTop2 = $elem2.offset().top;
        var elemBottom = elemTop + $elem.height();
        //console.log('hello',elemBottom,elemTop2, docViewBottom)
        if ((elemBottom < docViewBottom)) {
          $('.choose-keep-btn a').addClass("hide-btn");
          if(elemTop2 < docViewBottom){
            $('.choose-keep-btn a').removeClass("hide-btn");
          }
        } else {
          $('.choose-keep-btn a').removeClass("hide-btn");
        }
      });

  }
});  


$( document ).ready(function() {
  
  
  $(".shogun-heading-component b").on('click', function(event) {
      var hash = '#shop-section';
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function(){
          window.location.hash = hash;
        });
    });
  
  //console.log($("input[name*='variant-id']:checked").parents('.variant-checkbox').data('price'));
  $("input[name*='variant-id']:checked").parents('.variant-checkbox').trigger( "click" );
});

$( ".ProductForm" ).submit(function( e ) {
  
  
  var data = $(this).serialize();
  var formdata = $(this).serializeArray().reduce(function(obj, item) {
    obj[item.name] = item.value;
    return obj;
  }, {});

  if(formdata['addon-1'] || formdata['addon-2']) {
    e.preventDefault();
    var variants = [];
    //console.log(formdata);
    if(formdata['addon-1'])
      variants.push(formdata['addon-1-id']);
    if(formdata['addon-2'])
      variants.push(formdata['addon-2-id']);
    variants.push(formdata['id']);

    addmultiproduct = function() {
      if (variants.length) {
        var request = variants.shift();
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {"id":request, "quantity":1},
          dataType: 'json'
        }).then(function(){
          addmultiproduct();
        })
        .catch(function (error) {
          if (variants.length){
            addmultiproduct();
          }
        });
      }else{
        window.location.href = "/cart";
      }
    };

    addmultiproduct();
    
  
    //console.log(variants);
  }
});

$('.variant-checkbox').on('click', function(e){
  //console.log('ariant-checkbox');
  var id = $(this).data('id');
  $( "select[name*='id']").val(id);

  $('.addon_img').hide();
  if(id == '35953753489558'){
    $('.addon_img.32234098458717').show();
    $( "input[name*='addon-1-id']").val('32234098458717');
  }
  else if(id == '35953753522326'){
    $('.addon_img.32234098491485').show();
    $( "input[name*='addon-1-id']").val('32234098491485');
  }
  else if(id == '35953753555094'){
    $('.addon_img.32234098524253').show();
    $( "input[name*='addon-1-id']").val('32234098524253');
  }
  else if(id == '35953753587862'){
    $('.addon_img.32234424696925').show();
    $( "input[name*='addon-1-id']").val('32234424696925');
  }
  
  updateTotalPrice();
});

function updateTotalPrice(){
    var price = parseInt($("input[name*='variant-id']:checked").parents('.variant-checkbox').data('price'));
  var compare = parseInt($("input[name*='variant-id']:checked").parents('.variant-checkbox').data('compare'));
  
  if($("input[name*='addon-1']").is(":checked")){
    console.log('addon-1');
   	price = price + parseInt($("input[name*='addon-1']").parents('.addon-checkbox').data('price'));
    compare = compare + parseInt($("input[name*='addon-1']").parents('.addon-checkbox').data('compare'));
  }

  if($("input[name*='addon-2']").is(":checked")){
    price = price + parseInt($("input[name*='addon-2']").parents('.addon-checkbox').data('price'));
    compare = compare + parseInt($("input[name*='addon-2']").parents('.addon-checkbox').data('compare'));
  }
  //console.log(Shopify.formatMoney(price));
  //$('.total-price .Price--highlight .money').html(Shopify.formatMoney(price));
  $('.total-price .Price--highlight .money').attr('price-shop-ak', '$' + (price/100).toFixed(2));
  $('.total-price .Price--compareAt .money').attr('price-shop-ak', '$' + (compare/100).toFixed(2));
  //$('.total-price .Price--compareAt .money').html('$' + (compare/100).toFixed(2) + ' USD<i class="ak-d-none"></i>');
  $('#flags-active').trigger('click');
}

$('.addon-checkbox').on('click', function(e){
    updateTotalPrice();
});
